import { pipeMixins } from "../../mixins/pipeMixins";
import { uuidv4 } from "../../utilities/uuidv4";

const withVerticies = {
  verticies() {
    return this._verticies;
  },
  setVerticies(verticies) {
    this._verticies = verticies;
  },
  area(mPerPixel) {
    // calculate the area of the polygon in m^2
    let area = 0;
    let j = this._verticies.length - 1;
    for (let i = 0; i < this._verticies.length; i++) {
      let x1 = this._verticies[j].x * mPerPixel;
      let y1 = this._verticies[j].y * mPerPixel;
      let x2 = this._verticies[i].x * mPerPixel;
      let y2 = this._verticies[i].y * mPerPixel;
      area += (x1 + x2) * (y1 - y2);
      j = i;
    }
    return Math.abs(area / 2);
  },
  centroid() {
    // calculate the center of the polygon
    let x = 0;
    let y = 0;
    for (let i = 0; i < this._verticies.length; i++) {
      x += this._verticies[i].x;
      y += this._verticies[i].y;
    }
    x /= this._verticies.length;
    y /= this._verticies.length;
    return { x, y };
  },
};

const withLockable = {
  locked() {
    return this._locked;
  },
  lock() {
    this._locked = true;
  },
  unlock() {
    this._locked = false;
  },
  toggleLock() {
    this._locked = !this._locked;
  },
  setLocked(locked) {
    this._locked = locked;
  },
};

const withName = {
  name() {
    return this._name;
  },
  setName(name) {
    this._name = name;
  },
};

const withType = {
  type() {
    return this._type;
  },
  setType(type) {
    this._type = type;
  },
};

const withSelectable = {
  select() {
    this._selected = true;
  },
  deselect() {
    this._selected = false;
  },
  toggleSelect() {
    this._selected = !this._selected;
  },
  selected() {
    return this._selected;
  },
};

const withPlants = {
  plants() {
    return this._plants || [];
  },
  setPlants(plants) {
    this._plants = plants;
  },
  addPlant(plant) {
    if (!this._plants) this._plants = [];

    // if plant is already in list, increment count
    // let existingPlant = this._plants.find((p) => p.name === plant.name);
    // if (existingPlant) {
    //   existingPlant.quantity++;
    //   return;
    // }

    this._plants.push(plant);
  },
  removePlant(plant) {
    // if plant is in list, decrement count
    // let existingPlant = this._plants.find((p) => p.name === plant.name);
    // if (existingPlant) {
    //   existingPlant.quantity--;
    //   if (existingPlant.quantity <= 0) {
    //   }
    // }
    // find the plant in the list and remove it
    this._plants = this._plants.filter((p) => p !== plant);

    // this._plants = this._plants.filter((p) => p.name !== plant.name);
  },
};

export function polygonFromData(data) {
  let polygon = createPolygon(data.verticies);
  polygon.setName(data.name);
  polygon.setType(data.type);
  polygon.setPlants(data.plants);
  return polygon;
}

export function polygonsFromData(data) {
  return data.map((polygonData) => polygonFromData(polygonData));
}

export function createPolygon(verticies) {
  let polygon = pipeMixins(
    withVerticies,
    withLockable,
    withName,
    withType,
    withSelectable,
    withPlants
  );

  polygon.toData = function () {
    // do a plant sanity check because changed structure
    let plants = this.plants();

    // go through each plant change the plantImage property to image property then delete plantImage property
    plants.forEach((plant) => {
      if (plant.plantImage) {
        plant.image = plant.plantImage;
        delete plant.plantImage;
      }
      // if they dont have uid then add one
      if (!plant.uid) {
        plant.uid = uuidv4();
      }
    });

    return {
      verticies: this.verticies(),
      name: this.name(),
      type: this.type(),
      plants: plants || [],
    };
  };
  polygon.setVerticies(verticies);
  polygon.setLocked(false);
  polygon.setName("Polygon");
  polygon.setType("");
  polygon.deselect();
  return polygon;
}
